module.exports = __webpack_public_path__ + "img/digitaljoy-dark-theme.8527a769.svg";